import { Link } from "react-router-dom";
import SiteLayout from "../components/SiteLayout";
import { Button } from "../components/ui/button";
import { companyProfile } from "../data/siteContent";

const HomePage = () => {
  return (
    <SiteLayout>
      <div className="page-shell" data-testid="home-page">
        <section className="hero-grid hero-grid--home">
          <div>
            <div className="eyebrow stagger-1" data-testid="home-hero-eyebrow">
              Technology Studio
            </div>
            <h1 className="hero-heading stagger-2" data-testid="home-hero-heading">
              {companyProfile.name}
            </h1>
            <p className="hero-tagline stagger-3" data-testid="home-hero-tagline">
              {companyProfile.tagline}
            </p>
            <p className="hero-copy stagger-3" data-testid="home-hero-supporting-line">
              {companyProfile.supportingLine}
            </p>

            <div className="button-row stagger-4">
              <Button asChild className="primary-button" data-testid="home-about-company-button" size="lg">
                <Link to="/company">About the Company</Link>
              </Button>
              <Button
                asChild
                className="secondary-button"
                data-testid="home-our-work-button"
                size="lg"
                variant="secondary"
              >
                <Link to="/work">Our Work</Link>
              </Button>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
};

export default HomePage;